import React from 'react';
import ProductInterface from '../ProductInterface';
import BintempsOptions from './BintempsOptions';
import { processBintemps } from './bintempsProcess';

export default function Bintemps() {
  return (
      <ProductInterface
          product = "bintemps"
          ProductOptions = {BintempsOptions}
          processProduct = {processBintemps}
      />
  )
} 